/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ShareShareIdImport } from './routes/share/$shareId'
import { Route as LegalLayoutImport } from './routes/legal/_layout'
import { Route as AuthLayoutImport } from './routes/auth/_layout'
import { Route as AppLayoutImport } from './routes/app/_layout'
import { Route as AdminLayoutImport } from './routes/admin/_layout'
import { Route as WebLayoutImport } from './routes/_web/_layout'
import { Route as AppLayoutIndexImport } from './routes/app/_layout/index'
import { Route as AdminLayoutIndexImport } from './routes/admin/_layout/index'
import { Route as WebLayoutIndexImport } from './routes/_web/_layout/index'
import { Route as LegalLayoutTermsImport } from './routes/legal/_layout/terms'
import { Route as LegalLayoutPrivacyImport } from './routes/legal/_layout/privacy'
import { Route as AuthLayoutSignupImport } from './routes/auth/_layout/signup'
import { Route as AuthLayoutResetPasswordImport } from './routes/auth/_layout/reset-password'
import { Route as AuthLayoutRedirectImport } from './routes/auth/_layout/redirect'
import { Route as AuthLayoutLoginAdminImport } from './routes/auth/_layout/login-admin'
import { Route as AuthLayoutLoginImport } from './routes/auth/_layout/login'
import { Route as AuthLayoutForgotPasswordImport } from './routes/auth/_layout/forgot-password'
import { Route as AppLayoutUsageStatsImport } from './routes/app/_layout/usage-stats'
import { Route as AppLayoutSettingsImport } from './routes/app/_layout/settings'
import { Route as AppLayoutPersonalizationImport } from './routes/app/_layout/personalization'
import { Route as AppLayoutEditorsBriefImport } from './routes/app/_layout/editors-brief'
import { Route as WebLayoutContactImport } from './routes/_web/_layout/contact'
import { Route as WebLayoutAboutUsImport } from './routes/_web/_layout/about-us'
import { Route as WebLayoutBlogIndexImport } from './routes/_web/_layout/blog/index'
import { Route as AppLayoutEditorProjectIdImport } from './routes/app/_layout/editor/$projectId'
import { Route as WebLayoutBlogIdImport } from './routes/_web/_layout/blog/$id'

// Create Virtual Routes

const LegalImport = createFileRoute('/legal')()
const AuthImport = createFileRoute('/auth')()
const AppImport = createFileRoute('/app')()
const AdminImport = createFileRoute('/admin')()

// Create/Update Routes

const LegalRoute = LegalImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRoute,
} as any)

const AdminRoute = AdminImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRoute,
} as any)

const ShareShareIdRoute = ShareShareIdImport.update({
  id: '/share/$shareId',
  path: '/share/$shareId',
  getParentRoute: () => rootRoute,
} as any)

const LegalLayoutRoute = LegalLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => LegalRoute,
} as any)

const AuthLayoutRoute = AuthLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AuthRoute,
} as any)

const AppLayoutRoute = AppLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AppRoute,
} as any)

const AdminLayoutRoute = AdminLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AdminRoute,
} as any)

const WebLayoutRoute = WebLayoutImport.update({
  id: '/_web/_layout',
  getParentRoute: () => rootRoute,
} as any)

const AppLayoutIndexRoute = AppLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLayoutRoute,
} as any)

const AdminLayoutIndexRoute = AdminLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminLayoutRoute,
} as any)

const WebLayoutIndexRoute = WebLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WebLayoutRoute,
} as any)

const LegalLayoutTermsRoute = LegalLayoutTermsImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => LegalLayoutRoute,
} as any)

const LegalLayoutPrivacyRoute = LegalLayoutPrivacyImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => LegalLayoutRoute,
} as any)

const AuthLayoutSignupRoute = AuthLayoutSignupImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const AuthLayoutResetPasswordRoute = AuthLayoutResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const AuthLayoutRedirectRoute = AuthLayoutRedirectImport.update({
  id: '/redirect',
  path: '/redirect',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const AuthLayoutLoginAdminRoute = AuthLayoutLoginAdminImport.update({
  id: '/login-admin',
  path: '/login-admin',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const AuthLayoutLoginRoute = AuthLayoutLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const AuthLayoutForgotPasswordRoute = AuthLayoutForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthLayoutRoute,
} as any)

const AppLayoutUsageStatsRoute = AppLayoutUsageStatsImport.update({
  id: '/usage-stats',
  path: '/usage-stats',
  getParentRoute: () => AppLayoutRoute,
} as any)

const AppLayoutSettingsRoute = AppLayoutSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppLayoutRoute,
} as any)

const AppLayoutPersonalizationRoute = AppLayoutPersonalizationImport.update({
  id: '/personalization',
  path: '/personalization',
  getParentRoute: () => AppLayoutRoute,
} as any)

const AppLayoutEditorsBriefRoute = AppLayoutEditorsBriefImport.update({
  id: '/editors-brief',
  path: '/editors-brief',
  getParentRoute: () => AppLayoutRoute,
} as any)

const WebLayoutContactRoute = WebLayoutContactImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => WebLayoutRoute,
} as any)

const WebLayoutAboutUsRoute = WebLayoutAboutUsImport.update({
  id: '/about-us',
  path: '/about-us',
  getParentRoute: () => WebLayoutRoute,
} as any)

const WebLayoutBlogIndexRoute = WebLayoutBlogIndexImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => WebLayoutRoute,
} as any)

const AppLayoutEditorProjectIdRoute = AppLayoutEditorProjectIdImport.update({
  id: '/editor/$projectId',
  path: '/editor/$projectId',
  getParentRoute: () => AppLayoutRoute,
} as any)

const WebLayoutBlogIdRoute = WebLayoutBlogIdImport.update({
  id: '/blog/$id',
  path: '/blog/$id',
  getParentRoute: () => WebLayoutRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_web/_layout': {
      id: '/_web/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof WebLayoutImport
      parentRoute: typeof rootRoute
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminImport
      parentRoute: typeof rootRoute
    }
    '/admin/_layout': {
      id: '/admin/_layout'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminLayoutImport
      parentRoute: typeof AdminRoute
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/app/_layout': {
      id: '/app/_layout'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppLayoutImport
      parentRoute: typeof AppRoute
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/auth/_layout': {
      id: '/auth/_layout'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthLayoutImport
      parentRoute: typeof AuthRoute
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalImport
      parentRoute: typeof rootRoute
    }
    '/legal/_layout': {
      id: '/legal/_layout'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalLayoutImport
      parentRoute: typeof LegalRoute
    }
    '/share/$shareId': {
      id: '/share/$shareId'
      path: '/share/$shareId'
      fullPath: '/share/$shareId'
      preLoaderRoute: typeof ShareShareIdImport
      parentRoute: typeof rootRoute
    }
    '/_web/_layout/about-us': {
      id: '/_web/_layout/about-us'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof WebLayoutAboutUsImport
      parentRoute: typeof WebLayoutImport
    }
    '/_web/_layout/contact': {
      id: '/_web/_layout/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof WebLayoutContactImport
      parentRoute: typeof WebLayoutImport
    }
    '/app/_layout/editors-brief': {
      id: '/app/_layout/editors-brief'
      path: '/editors-brief'
      fullPath: '/app/editors-brief'
      preLoaderRoute: typeof AppLayoutEditorsBriefImport
      parentRoute: typeof AppLayoutImport
    }
    '/app/_layout/personalization': {
      id: '/app/_layout/personalization'
      path: '/personalization'
      fullPath: '/app/personalization'
      preLoaderRoute: typeof AppLayoutPersonalizationImport
      parentRoute: typeof AppLayoutImport
    }
    '/app/_layout/settings': {
      id: '/app/_layout/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppLayoutSettingsImport
      parentRoute: typeof AppLayoutImport
    }
    '/app/_layout/usage-stats': {
      id: '/app/_layout/usage-stats'
      path: '/usage-stats'
      fullPath: '/app/usage-stats'
      preLoaderRoute: typeof AppLayoutUsageStatsImport
      parentRoute: typeof AppLayoutImport
    }
    '/auth/_layout/forgot-password': {
      id: '/auth/_layout/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthLayoutForgotPasswordImport
      parentRoute: typeof AuthLayoutImport
    }
    '/auth/_layout/login': {
      id: '/auth/_layout/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLayoutLoginImport
      parentRoute: typeof AuthLayoutImport
    }
    '/auth/_layout/login-admin': {
      id: '/auth/_layout/login-admin'
      path: '/login-admin'
      fullPath: '/auth/login-admin'
      preLoaderRoute: typeof AuthLayoutLoginAdminImport
      parentRoute: typeof AuthLayoutImport
    }
    '/auth/_layout/redirect': {
      id: '/auth/_layout/redirect'
      path: '/redirect'
      fullPath: '/auth/redirect'
      preLoaderRoute: typeof AuthLayoutRedirectImport
      parentRoute: typeof AuthLayoutImport
    }
    '/auth/_layout/reset-password': {
      id: '/auth/_layout/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthLayoutResetPasswordImport
      parentRoute: typeof AuthLayoutImport
    }
    '/auth/_layout/signup': {
      id: '/auth/_layout/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthLayoutSignupImport
      parentRoute: typeof AuthLayoutImport
    }
    '/legal/_layout/privacy': {
      id: '/legal/_layout/privacy'
      path: '/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof LegalLayoutPrivacyImport
      parentRoute: typeof LegalLayoutImport
    }
    '/legal/_layout/terms': {
      id: '/legal/_layout/terms'
      path: '/terms'
      fullPath: '/legal/terms'
      preLoaderRoute: typeof LegalLayoutTermsImport
      parentRoute: typeof LegalLayoutImport
    }
    '/_web/_layout/': {
      id: '/_web/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof WebLayoutIndexImport
      parentRoute: typeof WebLayoutImport
    }
    '/admin/_layout/': {
      id: '/admin/_layout/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminLayoutIndexImport
      parentRoute: typeof AdminLayoutImport
    }
    '/app/_layout/': {
      id: '/app/_layout/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppLayoutIndexImport
      parentRoute: typeof AppLayoutImport
    }
    '/_web/_layout/blog/$id': {
      id: '/_web/_layout/blog/$id'
      path: '/blog/$id'
      fullPath: '/blog/$id'
      preLoaderRoute: typeof WebLayoutBlogIdImport
      parentRoute: typeof WebLayoutImport
    }
    '/app/_layout/editor/$projectId': {
      id: '/app/_layout/editor/$projectId'
      path: '/editor/$projectId'
      fullPath: '/app/editor/$projectId'
      preLoaderRoute: typeof AppLayoutEditorProjectIdImport
      parentRoute: typeof AppLayoutImport
    }
    '/_web/_layout/blog/': {
      id: '/_web/_layout/blog/'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof WebLayoutBlogIndexImport
      parentRoute: typeof WebLayoutImport
    }
  }
}

// Create and export the route tree

interface WebLayoutRouteChildren {
  WebLayoutAboutUsRoute: typeof WebLayoutAboutUsRoute
  WebLayoutContactRoute: typeof WebLayoutContactRoute
  WebLayoutIndexRoute: typeof WebLayoutIndexRoute
  WebLayoutBlogIdRoute: typeof WebLayoutBlogIdRoute
  WebLayoutBlogIndexRoute: typeof WebLayoutBlogIndexRoute
}

const WebLayoutRouteChildren: WebLayoutRouteChildren = {
  WebLayoutAboutUsRoute: WebLayoutAboutUsRoute,
  WebLayoutContactRoute: WebLayoutContactRoute,
  WebLayoutIndexRoute: WebLayoutIndexRoute,
  WebLayoutBlogIdRoute: WebLayoutBlogIdRoute,
  WebLayoutBlogIndexRoute: WebLayoutBlogIndexRoute,
}

const WebLayoutRouteWithChildren = WebLayoutRoute._addFileChildren(
  WebLayoutRouteChildren,
)

interface AdminLayoutRouteChildren {
  AdminLayoutIndexRoute: typeof AdminLayoutIndexRoute
}

const AdminLayoutRouteChildren: AdminLayoutRouteChildren = {
  AdminLayoutIndexRoute: AdminLayoutIndexRoute,
}

const AdminLayoutRouteWithChildren = AdminLayoutRoute._addFileChildren(
  AdminLayoutRouteChildren,
)

interface AdminRouteChildren {
  AdminLayoutRoute: typeof AdminLayoutRouteWithChildren
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminLayoutRoute: AdminLayoutRouteWithChildren,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppLayoutRouteChildren {
  AppLayoutEditorsBriefRoute: typeof AppLayoutEditorsBriefRoute
  AppLayoutPersonalizationRoute: typeof AppLayoutPersonalizationRoute
  AppLayoutSettingsRoute: typeof AppLayoutSettingsRoute
  AppLayoutUsageStatsRoute: typeof AppLayoutUsageStatsRoute
  AppLayoutIndexRoute: typeof AppLayoutIndexRoute
  AppLayoutEditorProjectIdRoute: typeof AppLayoutEditorProjectIdRoute
}

const AppLayoutRouteChildren: AppLayoutRouteChildren = {
  AppLayoutEditorsBriefRoute: AppLayoutEditorsBriefRoute,
  AppLayoutPersonalizationRoute: AppLayoutPersonalizationRoute,
  AppLayoutSettingsRoute: AppLayoutSettingsRoute,
  AppLayoutUsageStatsRoute: AppLayoutUsageStatsRoute,
  AppLayoutIndexRoute: AppLayoutIndexRoute,
  AppLayoutEditorProjectIdRoute: AppLayoutEditorProjectIdRoute,
}

const AppLayoutRouteWithChildren = AppLayoutRoute._addFileChildren(
  AppLayoutRouteChildren,
)

interface AppRouteChildren {
  AppLayoutRoute: typeof AppLayoutRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppLayoutRoute: AppLayoutRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthLayoutRouteChildren {
  AuthLayoutForgotPasswordRoute: typeof AuthLayoutForgotPasswordRoute
  AuthLayoutLoginRoute: typeof AuthLayoutLoginRoute
  AuthLayoutLoginAdminRoute: typeof AuthLayoutLoginAdminRoute
  AuthLayoutRedirectRoute: typeof AuthLayoutRedirectRoute
  AuthLayoutResetPasswordRoute: typeof AuthLayoutResetPasswordRoute
  AuthLayoutSignupRoute: typeof AuthLayoutSignupRoute
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthLayoutForgotPasswordRoute: AuthLayoutForgotPasswordRoute,
  AuthLayoutLoginRoute: AuthLayoutLoginRoute,
  AuthLayoutLoginAdminRoute: AuthLayoutLoginAdminRoute,
  AuthLayoutRedirectRoute: AuthLayoutRedirectRoute,
  AuthLayoutResetPasswordRoute: AuthLayoutResetPasswordRoute,
  AuthLayoutSignupRoute: AuthLayoutSignupRoute,
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
)

interface AuthRouteChildren {
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface LegalLayoutRouteChildren {
  LegalLayoutPrivacyRoute: typeof LegalLayoutPrivacyRoute
  LegalLayoutTermsRoute: typeof LegalLayoutTermsRoute
}

const LegalLayoutRouteChildren: LegalLayoutRouteChildren = {
  LegalLayoutPrivacyRoute: LegalLayoutPrivacyRoute,
  LegalLayoutTermsRoute: LegalLayoutTermsRoute,
}

const LegalLayoutRouteWithChildren = LegalLayoutRoute._addFileChildren(
  LegalLayoutRouteChildren,
)

interface LegalRouteChildren {
  LegalLayoutRoute: typeof LegalLayoutRouteWithChildren
}

const LegalRouteChildren: LegalRouteChildren = {
  LegalLayoutRoute: LegalLayoutRouteWithChildren,
}

const LegalRouteWithChildren = LegalRoute._addFileChildren(LegalRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof WebLayoutRouteWithChildren
  '/admin': typeof AdminLayoutRouteWithChildren
  '/app': typeof AppLayoutRouteWithChildren
  '/auth': typeof AuthLayoutRouteWithChildren
  '/legal': typeof LegalLayoutRouteWithChildren
  '/share/$shareId': typeof ShareShareIdRoute
  '/about-us': typeof WebLayoutAboutUsRoute
  '/contact': typeof WebLayoutContactRoute
  '/app/editors-brief': typeof AppLayoutEditorsBriefRoute
  '/app/personalization': typeof AppLayoutPersonalizationRoute
  '/app/settings': typeof AppLayoutSettingsRoute
  '/app/usage-stats': typeof AppLayoutUsageStatsRoute
  '/auth/forgot-password': typeof AuthLayoutForgotPasswordRoute
  '/auth/login': typeof AuthLayoutLoginRoute
  '/auth/login-admin': typeof AuthLayoutLoginAdminRoute
  '/auth/redirect': typeof AuthLayoutRedirectRoute
  '/auth/reset-password': typeof AuthLayoutResetPasswordRoute
  '/auth/signup': typeof AuthLayoutSignupRoute
  '/legal/privacy': typeof LegalLayoutPrivacyRoute
  '/legal/terms': typeof LegalLayoutTermsRoute
  '/': typeof WebLayoutIndexRoute
  '/admin/': typeof AdminLayoutIndexRoute
  '/app/': typeof AppLayoutIndexRoute
  '/blog/$id': typeof WebLayoutBlogIdRoute
  '/app/editor/$projectId': typeof AppLayoutEditorProjectIdRoute
  '/blog': typeof WebLayoutBlogIndexRoute
}

export interface FileRoutesByTo {
  '/admin': typeof AdminLayoutIndexRoute
  '/app': typeof AppLayoutIndexRoute
  '/auth': typeof AuthLayoutRouteWithChildren
  '/legal': typeof LegalLayoutRouteWithChildren
  '/share/$shareId': typeof ShareShareIdRoute
  '/about-us': typeof WebLayoutAboutUsRoute
  '/contact': typeof WebLayoutContactRoute
  '/app/editors-brief': typeof AppLayoutEditorsBriefRoute
  '/app/personalization': typeof AppLayoutPersonalizationRoute
  '/app/settings': typeof AppLayoutSettingsRoute
  '/app/usage-stats': typeof AppLayoutUsageStatsRoute
  '/auth/forgot-password': typeof AuthLayoutForgotPasswordRoute
  '/auth/login': typeof AuthLayoutLoginRoute
  '/auth/login-admin': typeof AuthLayoutLoginAdminRoute
  '/auth/redirect': typeof AuthLayoutRedirectRoute
  '/auth/reset-password': typeof AuthLayoutResetPasswordRoute
  '/auth/signup': typeof AuthLayoutSignupRoute
  '/legal/privacy': typeof LegalLayoutPrivacyRoute
  '/legal/terms': typeof LegalLayoutTermsRoute
  '/': typeof WebLayoutIndexRoute
  '/blog/$id': typeof WebLayoutBlogIdRoute
  '/app/editor/$projectId': typeof AppLayoutEditorProjectIdRoute
  '/blog': typeof WebLayoutBlogIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_web/_layout': typeof WebLayoutRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/admin/_layout': typeof AdminLayoutRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/app/_layout': typeof AppLayoutRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/auth/_layout': typeof AuthLayoutRouteWithChildren
  '/legal': typeof LegalRouteWithChildren
  '/legal/_layout': typeof LegalLayoutRouteWithChildren
  '/share/$shareId': typeof ShareShareIdRoute
  '/_web/_layout/about-us': typeof WebLayoutAboutUsRoute
  '/_web/_layout/contact': typeof WebLayoutContactRoute
  '/app/_layout/editors-brief': typeof AppLayoutEditorsBriefRoute
  '/app/_layout/personalization': typeof AppLayoutPersonalizationRoute
  '/app/_layout/settings': typeof AppLayoutSettingsRoute
  '/app/_layout/usage-stats': typeof AppLayoutUsageStatsRoute
  '/auth/_layout/forgot-password': typeof AuthLayoutForgotPasswordRoute
  '/auth/_layout/login': typeof AuthLayoutLoginRoute
  '/auth/_layout/login-admin': typeof AuthLayoutLoginAdminRoute
  '/auth/_layout/redirect': typeof AuthLayoutRedirectRoute
  '/auth/_layout/reset-password': typeof AuthLayoutResetPasswordRoute
  '/auth/_layout/signup': typeof AuthLayoutSignupRoute
  '/legal/_layout/privacy': typeof LegalLayoutPrivacyRoute
  '/legal/_layout/terms': typeof LegalLayoutTermsRoute
  '/_web/_layout/': typeof WebLayoutIndexRoute
  '/admin/_layout/': typeof AdminLayoutIndexRoute
  '/app/_layout/': typeof AppLayoutIndexRoute
  '/_web/_layout/blog/$id': typeof WebLayoutBlogIdRoute
  '/app/_layout/editor/$projectId': typeof AppLayoutEditorProjectIdRoute
  '/_web/_layout/blog/': typeof WebLayoutBlogIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/admin'
    | '/app'
    | '/auth'
    | '/legal'
    | '/share/$shareId'
    | '/about-us'
    | '/contact'
    | '/app/editors-brief'
    | '/app/personalization'
    | '/app/settings'
    | '/app/usage-stats'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/login-admin'
    | '/auth/redirect'
    | '/auth/reset-password'
    | '/auth/signup'
    | '/legal/privacy'
    | '/legal/terms'
    | '/'
    | '/admin/'
    | '/app/'
    | '/blog/$id'
    | '/app/editor/$projectId'
    | '/blog'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/admin'
    | '/app'
    | '/auth'
    | '/legal'
    | '/share/$shareId'
    | '/about-us'
    | '/contact'
    | '/app/editors-brief'
    | '/app/personalization'
    | '/app/settings'
    | '/app/usage-stats'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/login-admin'
    | '/auth/redirect'
    | '/auth/reset-password'
    | '/auth/signup'
    | '/legal/privacy'
    | '/legal/terms'
    | '/'
    | '/blog/$id'
    | '/app/editor/$projectId'
    | '/blog'
  id:
    | '__root__'
    | '/_web/_layout'
    | '/admin'
    | '/admin/_layout'
    | '/app'
    | '/app/_layout'
    | '/auth'
    | '/auth/_layout'
    | '/legal'
    | '/legal/_layout'
    | '/share/$shareId'
    | '/_web/_layout/about-us'
    | '/_web/_layout/contact'
    | '/app/_layout/editors-brief'
    | '/app/_layout/personalization'
    | '/app/_layout/settings'
    | '/app/_layout/usage-stats'
    | '/auth/_layout/forgot-password'
    | '/auth/_layout/login'
    | '/auth/_layout/login-admin'
    | '/auth/_layout/redirect'
    | '/auth/_layout/reset-password'
    | '/auth/_layout/signup'
    | '/legal/_layout/privacy'
    | '/legal/_layout/terms'
    | '/_web/_layout/'
    | '/admin/_layout/'
    | '/app/_layout/'
    | '/_web/_layout/blog/$id'
    | '/app/_layout/editor/$projectId'
    | '/_web/_layout/blog/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  WebLayoutRoute: typeof WebLayoutRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  LegalRoute: typeof LegalRouteWithChildren
  ShareShareIdRoute: typeof ShareShareIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  WebLayoutRoute: WebLayoutRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  LegalRoute: LegalRouteWithChildren,
  ShareShareIdRoute: ShareShareIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_web/_layout",
        "/admin",
        "/app",
        "/auth",
        "/legal",
        "/share/$shareId"
      ]
    },
    "/_web/_layout": {
      "filePath": "_web/_layout.tsx",
      "children": [
        "/_web/_layout/about-us",
        "/_web/_layout/contact",
        "/_web/_layout/",
        "/_web/_layout/blog/$id",
        "/_web/_layout/blog/"
      ]
    },
    "/admin": {
      "filePath": "admin",
      "children": [
        "/admin/_layout"
      ]
    },
    "/admin/_layout": {
      "filePath": "admin/_layout.tsx",
      "parent": "/admin",
      "children": [
        "/admin/_layout/"
      ]
    },
    "/app": {
      "filePath": "app",
      "children": [
        "/app/_layout"
      ]
    },
    "/app/_layout": {
      "filePath": "app/_layout.tsx",
      "parent": "/app",
      "children": [
        "/app/_layout/editors-brief",
        "/app/_layout/personalization",
        "/app/_layout/settings",
        "/app/_layout/usage-stats",
        "/app/_layout/",
        "/app/_layout/editor/$projectId"
      ]
    },
    "/auth": {
      "filePath": "auth",
      "children": [
        "/auth/_layout"
      ]
    },
    "/auth/_layout": {
      "filePath": "auth/_layout.tsx",
      "parent": "/auth",
      "children": [
        "/auth/_layout/forgot-password",
        "/auth/_layout/login",
        "/auth/_layout/login-admin",
        "/auth/_layout/redirect",
        "/auth/_layout/reset-password",
        "/auth/_layout/signup"
      ]
    },
    "/legal": {
      "filePath": "legal",
      "children": [
        "/legal/_layout"
      ]
    },
    "/legal/_layout": {
      "filePath": "legal/_layout.tsx",
      "parent": "/legal",
      "children": [
        "/legal/_layout/privacy",
        "/legal/_layout/terms"
      ]
    },
    "/share/$shareId": {
      "filePath": "share/$shareId.tsx"
    },
    "/_web/_layout/about-us": {
      "filePath": "_web/_layout/about-us.tsx",
      "parent": "/_web/_layout"
    },
    "/_web/_layout/contact": {
      "filePath": "_web/_layout/contact.tsx",
      "parent": "/_web/_layout"
    },
    "/app/_layout/editors-brief": {
      "filePath": "app/_layout/editors-brief.tsx",
      "parent": "/app/_layout"
    },
    "/app/_layout/personalization": {
      "filePath": "app/_layout/personalization.tsx",
      "parent": "/app/_layout"
    },
    "/app/_layout/settings": {
      "filePath": "app/_layout/settings.tsx",
      "parent": "/app/_layout"
    },
    "/app/_layout/usage-stats": {
      "filePath": "app/_layout/usage-stats.tsx",
      "parent": "/app/_layout"
    },
    "/auth/_layout/forgot-password": {
      "filePath": "auth/_layout/forgot-password.tsx",
      "parent": "/auth/_layout"
    },
    "/auth/_layout/login": {
      "filePath": "auth/_layout/login.tsx",
      "parent": "/auth/_layout"
    },
    "/auth/_layout/login-admin": {
      "filePath": "auth/_layout/login-admin.tsx",
      "parent": "/auth/_layout"
    },
    "/auth/_layout/redirect": {
      "filePath": "auth/_layout/redirect.tsx",
      "parent": "/auth/_layout"
    },
    "/auth/_layout/reset-password": {
      "filePath": "auth/_layout/reset-password.tsx",
      "parent": "/auth/_layout"
    },
    "/auth/_layout/signup": {
      "filePath": "auth/_layout/signup.tsx",
      "parent": "/auth/_layout"
    },
    "/legal/_layout/privacy": {
      "filePath": "legal/_layout/privacy.tsx",
      "parent": "/legal/_layout"
    },
    "/legal/_layout/terms": {
      "filePath": "legal/_layout/terms.tsx",
      "parent": "/legal/_layout"
    },
    "/_web/_layout/": {
      "filePath": "_web/_layout/index.tsx",
      "parent": "/_web/_layout"
    },
    "/admin/_layout/": {
      "filePath": "admin/_layout/index.tsx",
      "parent": "/admin/_layout"
    },
    "/app/_layout/": {
      "filePath": "app/_layout/index.tsx",
      "parent": "/app/_layout"
    },
    "/_web/_layout/blog/$id": {
      "filePath": "_web/_layout/blog/$id.tsx",
      "parent": "/_web/_layout"
    },
    "/app/_layout/editor/$projectId": {
      "filePath": "app/_layout/editor/$projectId.tsx",
      "parent": "/app/_layout"
    },
    "/_web/_layout/blog/": {
      "filePath": "_web/_layout/blog/index.tsx",
      "parent": "/_web/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
